import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import rootSaga from './rootSaga';
import threadsReducer from '../containers/Inbox/redux/threadSlice';
import messageThreadReducer from '../containers/Chat/redux/messageThreadSlice';
var sagaMiddleware = createSagaMiddleware();
var store = configureStore({
    reducer: {
        messageThread: messageThreadReducer,
        messageThreads: threadsReducer,
    },
    middleware: function (getDefaultMiddleware) {
        return getDefaultMiddleware({ thunk: false, serializableCheck: false }).concat(sagaMiddleware);
    },
});
sagaMiddleware.run(rootSaga);
export default store;
